import {Pair} from "@/library/types/pair"

export const classNames = (...input: (Pair<string, boolean | any> | string | string[] | undefined)[]) =>
    input.map(entry => {
        if (entry === undefined)
            return ""

        if (typeof entry == "string")
            return entry.trim()

        if (entry instanceof Array)
            return entry.map(item => item.trim()).join(" ")

        if (entry.valueB)
            return entry.valueA.trim()
    }).filter(entry => entry != undefined && entry != "")
        .join(" ")
        .trim()
